import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { ClientsReportPage } from '@/features/reports/clients/clients-report-page'
import { formatDocumentTitle } from '@/lib/document-title'

/** Reports › Clients at `/$orgId/reports/clients`, open to every report viewer. */
export const Route = createFileRoute('/_auth/$orgId/reports/clients')({
  component: ClientsRoute,
})

function ClientsRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Clients')}</title>
      </Helmet>
      <ClientsReportPage />
    </>
  )
}
